module.exports = __webpack_public_path__ + "assets/preact.0931d612.svg";